import { render, staticRenderFns } from "./Add-ModulePage.vue?vue&type=template&id=3a2cff3f&scoped=true&"
import script from "./Add-ModulePage.vue?vue&type=script&lang=js&"
export * from "./Add-ModulePage.vue?vue&type=script&lang=js&"
import style0 from "./Add-ModulePage.vue?vue&type=style&index=0&id=3a2cff3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2cff3f",
  null
  
)

export default component.exports